import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const SwitchWrap = styled.div`
  letter-spacing : 0;
  text-align : center;
  font-size : 0.5rem;
  position : relative;
  margin : auto;
`
const SwitchInput = styled.input`
  display: none;
  :checked ~ label {
    background: #555;
    span:after {
      content : "";
      padding : 0;
      color : #fff;
    }
    #swImg {
      transform : translateX(2rem);
      background  : #fff;
    }
  }
`
const SwitchLabel = styled.label`
  line-height: 1.25rem;
  height: 1.25rem;
  display: block;
  box-sizing: content-box;
  border-radius: 15px;
  width: 4rem;
  cursor: pointer;
  background: ${props => props.isNoChange ? '#555' : '#048B63'};
  cursor: ${props => props.isNoChange ? 'no-drop' : 'pointer'};
  span:after{
    content : "";
    padding : 0;
    color : #fff;
    font-size: 12px;
  }
`
const SwitchCircle = styled.div`
  position : absolute;
  width  : 0.75rem;
  height  : 0.75rem;
  background : ${props => props.isNoChange ? '#fff' : '#fff'};
  top: 0.25rem;
  left: 0.75rem;
  border-radius :10px;
  transition: .2s;
`


const SwitchButton = (props) => {
  const { switchName, flg, onChangeFlg, isNoChange } = props
  const switchRef = useRef()

  useEffect(() => {
    if (switchRef) {
      switchRef.current.checked = flg === 0
    }
  }, [flg])

  const changeFlg = () => {
    if (!isNoChange) {
      switchRef.current.checked = switchRef.current.checked !== true
      if (typeof onChangeFlg === "function")
        onChangeFlg()
    }
  }
  return (
    <SwitchWrap onClick={() => changeFlg()}>
      <SwitchInput name={switchName} type='checkbox' ref={switchRef} />
      <SwitchLabel htmlFor={switchName} isNoChange={isNoChange}>
        <span />
        <SwitchCircle id='swImg' isNoChange={isNoChange} />
      </SwitchLabel>
    </SwitchWrap>
  )
}

SwitchButton.propTypes = {
  switchName: PropTypes.string,
  flg: PropTypes.number,
  onChangeFlg: PropTypes.func,
  isNoChange: PropTypes.bool
}

export default SwitchButton
